import React, { useState, useEffect } from "react";
import { Popover, TextField, Box, Button } from "@mui/material";
import { filterPopoverStyles } from "Constants/Style";

type FilterPopoverProps = {
  column: any;
  setColValue: (cb: (prev: any[]) => any[]) => void;
  iconColor?: string;
};

const DateRangeFilterPopover = ({
  column,
  setColValue,
  iconColor,
}: FilterPopoverProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [fromDate, setFromDate] = useState<string>("");
  const [toDate, setToDate] = useState<string>("");

  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<Element>) => {
    setAnchorEl(e.currentTarget as HTMLElement);
  };

  const handleClose = () => {
    setAnchorEl(null);
    column.setFilterValue(undefined);
    setColValue((prev: any[]) =>
      (prev || []).filter((f) => f.filterField !== column.id)
    );
    setFromDate("");
    setToDate("");
  };

  const handleApply = () => {
    // Allow filtering with just from date, just to date, or both
    if (fromDate || toDate) {
      const filterValue: any = {};
      if (fromDate) filterValue.from_date = fromDate;
      if (toDate) filterValue.to_date = toDate;

      // Debug: Log filter application
      console.log("DateRangeFilterPopover - Applying filter:", {
        columnId: column.id,
        accessorKey: column.columnDef?.accessorKey,
        filterValue,
      });

      column.setFilterValue(filterValue);
      setColValue((prev: any[]) => {
        const updated = (prev || []).filter((f) => f.filterField !== column.id);
        const newFilter = { filterField: column.id, filterValue };
        console.log("DateRangeFilterPopover - Updated filters:", [...updated, newFilter]);
        return [...updated, newFilter];
      });
    }
    setAnchorEl(null);
  };

  useEffect(() => {
    const applied = column.getFilterValue();
    if (applied) {
      setFromDate(applied?.from_date || "");
      setToDate(applied?.to_date || "");
    }
  }, [column]);

  return (
    <>
      <i
        className="ri-filter-line"
        onClick={handleOpen}
        style={{ cursor: "pointer", marginLeft: 6, color: iconColor, fontSize: "14px" }}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} width={250} sx={filterPopoverStyles.container}>
          <TextField
            label="From"
            type="date"
            value={fromDate}
            fullWidth
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setFromDate(e.target.value)}
            sx={filterPopoverStyles.textField}
          />
          <Box mt={2}>
            <TextField
              label="To"
              type="date"
              value={toDate}
              fullWidth
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setToDate(e.target.value)}
              sx={filterPopoverStyles.textField}
            />
          </Box>

          <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
            <Button
              size="small"
              variant="outlined"
              onClick={handleClose}
              sx={filterPopoverStyles.cancelButton}
            >
              Cancel
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={handleApply}
              disabled={!fromDate && !toDate}
              sx={filterPopoverStyles.applyButton}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default DateRangeFilterPopover;
